import workOrderType from '@/views/hooks/workorderType'
const defaultQuery = {
  businessType: 33, //工单类型
  createdOnFrom: '', //工单创建开始时间
  createdOnTo: '', //工单创建结束时间
  curPage: 0, //当前页
  erpSn: '', //ERP编号
  pageSize: 10, //每页条数
  parentId: null, //关联健管工单ID
  ucBdName: '', //姓名
  workOrderId: null, //工单ID
  orderCycle: []
}
const workOrderTypeMap = workOrderType.filter(item => item.eventType === 33)
export { defaultQuery, workOrderTypeMap }
